import Api from './api';


export const addItem = async (formData) => { 
  let data = []
  await Api.post(`/knowledgebasecalleds`, formData)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
}

